import React, {Component} from 'react';
import {connect} from 'react-redux';
import Properties from '../../shared/Properties';
import {fetchProperties, fetchContractors} from '../../../actions';

class Container extends Component {
    componentDidMount() {
        return this.props.fetchContractors(this.props.landlord);
    }
    render() {
        return <Properties {...this.props} includeHeader={true}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const properties = state.landlord.properties.active;
    return {
        landlord: state.me.application.id,
        properties: [...properties.data],
        meta: properties.meta,
        loading: properties.isFetching,
        contractors: state.landlord.contractors.data
    };
};

export default connect(mapStateToProps, {
    fetchProperties,
    fetchContractors
})(Container);



// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/property/Properties.js